import {useEffect, useState} from 'react';
import {ScrollToAnchorPoint} from '../../../util/ScrollToAnchor';
import NotificationIcon from "./NotificationIcon";
import {Communication} from "../../../util/types";
import {patchSelfcareCommunication} from "../../../util/request";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import NotificationHead from "./NotificationHead";
import NotificationButtons from "./NotificationButtons";
import NotificationBody from "./NotificationBody";
import LoaderSpinner from '../../loaders/LoaderSpinner';

interface NotificationProps {
    request: Communication;
    onUpdate?: (request: Communication) => void;
}

export default function Notification({request, onUpdate}: NotificationProps) {
    const {customer} = useCustomer();

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsOpen(request.read_dtm === null);
    }, [request]);

    const handleToggleReadClick = (request: Communication) => {
        setIsLoading(true)
        patchSelfcareCommunication(customer.customer_id, request.request_id, {read: request.read_dtm === null})
            .then(r => onUpdate && onUpdate(r.response.data))
            .catch(() => {})
            .finally(() => setIsLoading(false))
    }

    if (isLoading) {
        return <LoaderSpinner/>
    }

    // Buttons for mark as read and folding
    const unreadClass = request.read_dtm === null ? " unread" : "";
    const openClass = isOpen ? " open" : "";
    const importantClass = request.important ? " important" : "";
    const classNames = unreadClass + openClass + importantClass;

    return <li className={`selfcare-notification${classNames}`}>
        <ScrollToAnchorPoint id={'notifikation-' + request.request_id.toString()} className="id-anchor--selfcare-notification"/>
        <NotificationIcon icon={request.icon}/>
        <NotificationHead
            subject={request.subject}
            sent_dtm={request.sent_dtm}
        />
        <NotificationButtons
            request={request}
            isOpen={isOpen}
            onToggleOpen={setIsOpen}
            onToggleRead={handleToggleReadClick}
        />
        <NotificationBody body={request.body}/>
    </li>;
}
